export default "__VITE_ASSET__Dsmwy0yL__"